/**
 * 增强版格式化函数
 */
export const formatNumberToWan = (num, options = {}) => {
    const {
        decimalPlaces = 1,      // 小数位数
        unit = 'w',             // 单位
        threshold = 10000,      // 阈值，超过这个值添加单位
        forceDecimal = false    // 是否强制显示小数
    } = options;
    
    if (num == null || num === '') return '0';
    
    const number = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(number)) return '0';
    
    const absoluteNum = Math.abs(number);
    const isNegative = number < 0;
    
    // 判断是否超过阈值
    if (absoluteNum < threshold) {
        return isNegative ? `-${absoluteNum}` : absoluteNum.toString();
    }
    
    // 超过阈值，添加单位
    const scaledValue = absoluteNum / threshold;
    
    let formatted;
    if (scaledValue % 1 === 0 && !forceDecimal) {
        // 整数
        formatted = scaledValue.toString();
    } else {
        // 小数
        formatted = scaledValue.toFixed(decimalPlaces);
        // 移除尾随的零
        formatted = formatted.replace(/\.?0+$/, '');
    }
    
    return isNegative ? `-${formatted}${unit}` : `${formatted}${unit}`;
};